import { twMerge } from 'tailwind-merge';

export const AI_CONTENT_LABEL = 'Yapay zeka destekli içerik';

export const AiContentLabel = ({ className }: { className?: string }) => {
  return (
    <span
      className={twMerge(
        'absolute bottom-1.5 left-1.5 z-[2] max-w-[calc(100%-0.75rem)] rounded px-1.5 py-1 text-[7px] font-bold leading-tight text-gray-700 md:bottom-2.5 md:left-2.5 md:text-[9px]',
        className
      )}
    >
      {AI_CONTENT_LABEL}
    </span>
  );
};
